import { render, staticRenderFns } from "./d_internal-answers.vue?vue&type=template&id=312ade59"
import script from "./d_internal-answers.vue?vue&type=script&lang=js"
export * from "./d_internal-answers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports